(() => {
  const initElleGemFilm = () => {
    const video = document.getElementById('egc-brand-film');
    const button = document.querySelector('.egc-film__sound');
    if (!video || !button || button.dataset.ready === 'true') return;
    button.dataset.ready = 'true';
    const label = button.querySelector('.egc-film__sound-label');
    button.addEventListener('click', async () => {
      video.muted = !video.muted;
      if (video.paused) {
        try { await video.play(); } catch (_) {}
      }
      button.setAttribute('aria-pressed', String(!video.muted));
      label.textContent = video.muted ? 'Sound on' : 'Sound off';
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initElleGemFilm, { once: true });
  } else {
    initElleGemFilm();
  }
  document.addEventListener('shopify:section:load', initElleGemFilm);
})();
